import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PreferencesItem.module.scss';
import Toggle from '../../../../components/Toggle/Toggle';

export const PreferencesItem = ({ item, toggleSetting }) => {
  const { t } = useTranslation();

  const toggleAction = useCallback(
    event => {
      const checked = event.target.checked;
      toggleSetting(item.setting, checked);
    },
    [item]
  );

  return (
    <li className={styles.preferenceItemContainer}>
      <p>{t(item.text)}</p>
      <Toggle id={item.text} size={'medium'} checked={item.value} onChange={toggleAction} key={item.setting}>
        Active
      </Toggle>
    </li>
  );
};
